export default __webpack_public_path__ + "static/media/map-pin-fill.3a663887.svg";